/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
import { 
    // 送出事件log紀錄
    sendEventLog,
    // 送出錯誤log紀錄
    sendErrorLog
} from "@/apis/global/log.js"; 
const types = {
}

// count state 必須是 Object
const state = {
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
}

// actions 也是以 Object 形式建構。
const actions = {
    sendEventLog ( {commit}, event ) {
        return new Promise((resolve, reject) => {
            const data = {
                event: event
            }
            sendEventLog(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }
            })
            .catch(err => {
            })
        })
    },
    sendErrorLog ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            sendErrorLog(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }
            })
            .catch(err => {
            })
        })
    },
    globalSendLoginLog ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            sendLoginLog(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                }
            })
            .catch(err => {
            })
        })
    },
}

// mutations
const mutations = {
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/global/log.js